/*
 * Copyright (C) Zoomdata, Inc. 2012-2022. All rights reserved.
 */
export const initializeEmbedBundlesRegistry = (global) => {
    if (global.__logi__?.embedBundles) {
        return global;
    }
    const Registry = new Map();
    const ResolverRegistry = new Map();
    global.__logi__ = Object.assign(global.__logi__ || {}, {
        embedBundles: {
            initialize: (name) => {
                const promise = new Promise((resolve, reject) => {
                    ResolverRegistry.set(name, {
                        resolve,
                        reject,
                    });
                });
                Registry.set(name, promise);
                return promise;
            },
            register: (name, embedComponent) => {
                if (!ResolverRegistry.has(name)) {
                    throw new Error('No Registered Embed Component! Cannot Register!');
                }
                const resolver = ResolverRegistry.get(name);
                resolver?.resolve(embedComponent);
            },
            get: (name) => {
                return Registry.get(name);
            },
            loadFailure: (name, error) => {
                if (!ResolverRegistry.has(name)) {
                    throw new Error('No Registered Embed Component! Error registering load failure!');
                }
                const resolver = ResolverRegistry.get(name);
                resolver?.reject(error);
            },
        },
    });
};
//# sourceMappingURL=EmbedBundlesRegistry.js.map